var $=jQuery;
$(document).ready(function () {
  $(document).on('click', '.trust__icons_ft .icon-with-text-item', function (e) {
    var url = $(this).attr('data-url');
    if (!url) return;            // only redirect when link exists
    location.href = url;         // simple redirect
  });
  var isDragging = false;

  $('.hover-card-grid')
      .on('dragStart.flickity', function () {
          isDragging = true;
      })
      .on('dragEnd.flickity', function () {
          setTimeout(function () {
              isDragging = false;
          }, 50);
      });

  $(document).on('click', '.hover-card-front', function (e) {
      if ($(window).width() < 991 && !isDragging) {
          $(this).toggleClass('active');
      }
  });
  $(document).on('click', '.hover-card-back', function (e) {
      if ($(window).width() < 991 && !isDragging) {
          $('.hover-card-front').removeClass('active');
      }
  });
  $('.footer-block.has-dropdown .footer-block__heading,.toc-header-title').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
    });
  //initFlickityMobile
    function initFlickityMobile() {
        var $lists1 = $(".announcement-bar-slider .slider--everywhere");
        var $lists = $(".nt_trust_icons .static-items,.trust__icons_ft .static-items.col-4,.nt_col_jah .multicolumn-list");
        var $lists_left = $(".nt_vintage .multicolumn-list,.nt_mehrzuentdecken .multicolumn-list");
        var $list_dots = $(".slider_mb .multicolumn-list,.blog-articles.custom-article-grid,.nt_augenoptik_noch_sec ul,.hover-card-grid");
        var $list_arrow = $("ul.subcategories-list");
        if ($(window).width() < 950) {
          $lists1.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: false,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 3000,
                        groupCells: false,
                        cellAlign: 'center'
                    });
                }
            });

            $lists.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: false,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 10000,
                        groupCells: false,
                        cellAlign: 'center'
                    });
                }
            });
            $lists_left.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 10000,
                        groupCells: false,
                        cellAlign: 'left'
                    });
                }
            });
            $list_dots.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 10000,
                        groupCells: false,
                        cellAlign: 'center'
                    });
                }
            });
            $list_arrow.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: false,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: true,
                        autoPlay: 10000,
                        groupCells: false,
                        cellAlign: 'center'
                    });
                }
            });
        } else {
            $lists.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $list_dots.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $lists_left.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            // $lists_arrow.each(function() {
            //     if ($(this).data('flickity')) {
            //         $(this).flickity('destroy');
            //     }
            // });
        }
    }
    $(document).ready(initFlickityMobile);
    $(window).on('resize', initFlickityMobile);
});
/*** LOAD MORE **/


$(document).on('click', '.color-custom.color-option', function(){
  var $swatch = $(this);
  var $card = $swatch.closest('.card');

  // 1) IMAGE
  var newImage = $swatch.attr('data-image');
  if (newImage) {
    $card.find('.media--hover-effect img').attr('src', newImage).attr('srcset', newImage);
  }

  // 2) PRICE & COMPARE
  var rawPrice = parseInt($swatch.attr('data-price'));
  var rawCompare = parseInt($swatch.attr('data-compare-price'));

  var priceNumber = rawPrice ? rawPrice / 100 : null;
  var compareNumber = rawCompare ? rawCompare / 100 : null;

  var formattedPrice = priceNumber !== null ? "€" + priceNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null;
  var formattedCompare = compareNumber !== null ? "€" + compareNumber.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null;

  var onSale = compareNumber && priceNumber && compareNumber > priceNumber;

  // 3) RENDER PRICE
  var $priceWrapper = $card.closest('.card-wrapper').find('.price');
  if ($priceWrapper.length && formattedPrice) {
    if (onSale) {
      $priceWrapper.html(`
        <div class="price__container">
          <div class="price__sale">
            <span class="price-item price-item--regular"><s>${formattedCompare}</s></span>
            <span class="price-item price-item--sale price-item--last">${formattedPrice}</span>
          </div>
        </div>
      `);
    } else {
      $priceWrapper.html(`
        <div class="price__container">
          <div class="price__regular">
            <span class="price-item price-item--regular">${formattedPrice}</span>
          </div>
        </div>
      `);
    }
  }

  // 4) SALE BADGE %
  var $badge = $card.find('.card__badge .badge.on_sale');
  if (onSale) {
    var percent = Math.round((1 - priceNumber / compareNumber) * 100);
    $badge.text(`-${percent}%`).show();
  } else {
    $badge.hide();
  }

  // 5) ACTIVE CLASS
  $card.find('.color-custom.color-option').removeClass('selected');
  $swatch.addClass('selected');
});



  $(document).on('click', '[data-pagination-link]', function(e) {
    e.preventDefault();
    const $button = $(this);
    const nextUrl = $button.attr('href');

    $button.text("Laden...");
    $button.prop('disabled', true);

    $.get(nextUrl, function(response) {
        const $tempDiv = $('<div>').html(response);
        const newProductsHtml = $tempDiv.find('#product-grid').html();
        const $newButton = $tempDiv.find('[data-pagination-link]');
        
        $('ul#product-grid').append(newProductsHtml);
        $button.closest('.show_more_btn').remove(); // remove old button wrapper

        if ($newButton.length) {
            $('ul#product-grid').after($newButton.closest('.show_more_btn')); // add new button wrapper
        }
    }).fail(function() {
        console.error('Error loading more products.');
        $button.text("Try again");
        $button.prop('disabled', false);
    });
});





$(document).on('change', '.select__select', function () {
  var $select = $(this);
  var $productItem = $select.closest('.pdp_detail');

  var selectedOptions = [];

  $productItem.find('.select__select').each(function () {
    selectedOptions.push($(this).val());
  });

  var variants = JSON.parse($productItem.attr('data-variants'));

  var matchedVariant = variants.find(function (variant) {
    return variant.options.every(function (opt, index) {
      return opt === selectedOptions[index];
    });
  });

  if (matchedVariant) {
    var $priceContainer = $productItem.find('.price-custom');
    var priceHtml = '';

    if (matchedVariant.compare_at_price > matchedVariant.price) {
      priceHtml += '<span class="sale-price">' + formatMoney(matchedVariant.price) + '</span>';
      priceHtml += '<span class="original-price">' + formatMoney(matchedVariant.compare_at_price) + '</span>';
      priceHtml += '<span class="du-sparst">Du sparst ' + formatMoney(matchedVariant.compare_at_price - matchedVariant.price) + '</span>';
    } else {
      priceHtml += '<span class="regular-price">' + formatMoney(matchedVariant.price) + '</span>';
    }

    $priceContainer.html(priceHtml);

    $productItem.find('.product-variant-id').val(matchedVariant.id);
    var $btn = $productItem.find('button[type="submit"]');
    if (matchedVariant.available) {
      $btn.prop('disabled', false);
    } else {
      $btn.prop('disabled', true);
    }
  }
});






/*** MINI CART ***/
$(document).on("change", ".custom-gutschein-variant-select", function() {
  var $select = $(this);
  var $form = $select.closest("form");
  var $button = $form.find(".submit_form");

  $button.attr("data-pro-id", $select.val());
});

$(document).on("click", ".submit_form", function(e) {
  e.preventDefault();

  var $button = $(this);
  var $form = $button.closest("form");
  var variantId = $form.find('[name="id"]').val() || $button.attr("data-pro-id");

  if (!variantId) {
    console.error("Variant ID not found");
    return;
  }

  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + "cart/add.js",
    data: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    }),
    dataType: "json",
    contentType: "application/json",
    success: function(data) {
      var url = new URL(window.location.href);
      url.searchParams.set("open_cart", "1");
      window.location.href = url.toString();
    },
    error: function(xhr, status, error) {
      console.error("Add to cart error:", error);
      console.error(xhr.responseText);
    }
  });
});
/*** MINI CART ***/


const params = new URLSearchParams(window.location.search);
if (params.get('open_cart') === '1') {
   const cartToggle = document.querySelector('#cart-icon-bubble');
    if (cartToggle) {
      cartToggle.click();
  }
  params.delete('open_cart');
  history.replaceState({}, '', `${location.pathname}?${params}`);
}

$(document).ready(function() {
    // Function to show the popup with an effect
    function showPopup() {
        $("#popup-overlay").fadeIn('slow');
        $("#popup-content").fadeIn('slow');
    }
    function hidePopup() {
        $("#popup-overlay").fadeOut('slow');
        $("#popup-content").fadeOut('slow');
    }
    $('.button_label_store a[href="#popup_store"]').click(function(event) {
      event.preventDefault();
        showPopup();
    });
    $("#close-popup").click(function() {
        hidePopup();
    });
    $("#popup-overlay").click(function() {
        hidePopup();
    });
    $(document).on("change", ".box-popup-content-store select.select", function(e) {
      // $(".alert-outofstock, .alert-outofstock, .submit-order-store").hide();
      var Filiale = $(this).val();
      var Artikel = $("#artikel_pdp").val();
      //var Artikel = '1106394';
      $("#get_filiale").val(Filiale);
      $.getJSON("https://shopify-sync.krass-optik.com/get-lagerbestand.php?Artikel="+Artikel+"&Filiale="+Filiale, function(data) {
        var stock = data.Lagerbestand;
        if(stock > 0){
          $(".alert-outofstock").hide();
          $(".submit-order-store").show();
        }
        else{
          $(".alert-outofstock").show();
          $(".submit-order-store").hide();
        }
      });
    });
    $(".submit-order-store-bk").submit(function(event) {
      event.preventDefault();
      var ReservierungFiliale = $("#get_filiale").val(); 
      var KundenNummer = $("#get_kundenNummer").val();
      var ArtikelNummer = $("#get_artikelnummer").val();
      var Name = $("#get_first_name").val();
      var Vorname = $("#get_last_name").val();
      var Anrede = $('input[name="Anrede"]:checked').val();
      var Email = $("#get_email").val();
      const formData = { 
          ReservierungFiliale: parseInt(ReservierungFiliale),
          KundenNummer: parseInt(KundenNummer),
          ArtikelNummer: parseInt(ArtikelNummer),
          Name: Name,
          Vorname: Vorname,
          Anrede: Anrede,
          Email: Email
      };
      const jsonData = JSON.stringify(formData);
      $.ajax({
        url: "https://shopify-sync.krass-optik.com/postReservierung.php",
        type: "POST",
        contentType: 'application/json',
        dataType: 'json',
        headers: {
          'Accept': 'application/json'
        },
        data: jsonData,
        success: function(response) {
          console.log(response);
        },
        error: function(jqXHR, textStatus, errorThrown) {
           console.error("Error:", textStatus, errorThrown);
        }
    });
    });
});

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('video');

  videos.forEach((video) => {
    video.addEventListener('play', () => {

      document.querySelectorAll('video').forEach((otherVideo) => {
        if (otherVideo !== video) {
          otherVideo.pause();
        }
      });

    });
  });
});